import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

export default function GuestGuard({ children }) {
  const { isLoggedIn, isInitialized } = useAuth();

  if (!isInitialized) return <Loader />;
  if (isLoggedIn) return <Navigate to="/" replace />;

  return children;
}

GuestGuard.propTypes = { children: PropTypes.node };
